import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { forEach, isEmpty, isObject } from 'lodash'
import { Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { HttpStatus } from '../../shared/constants/enums'
import { ApiError, ObjectValidationError, ResponseError } from '../../shared/models/api-error.interfaces'
import { ToastService } from '../services/toast.service'

@Injectable()
export class ErrorResponseInterceptor implements HttpInterceptor {
    static ignoredCodes: number[] = [HttpStatus.NOT_ACCEPTABLE, HttpStatus.UNAUTHORIZED]

    constructor(
        private router: Router,
        private toastService: ToastService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((httpError: HttpErrorResponse): never => {
                if (!ErrorResponseInterceptor.ignoredCodes.includes(httpError.status)) {
                    const responseError: ResponseError = httpError.error
                    this.handleError(responseError)
                }
                throw httpError
            })
        )
    }

    private async handleError(responseError: ResponseError): Promise<void> {
        const errorData: ApiError =
            responseError instanceof Blob ? JSON.parse(await responseError.text()) : responseError
        switch (errorData?.statusCode) {
            case HttpStatus.NOT_FOUND:
                await this.router.navigateByUrl('404', { skipLocationChange: true })
                break
            case HttpStatus.CONTENT_TOO_LARGE:
                this.toastService.showWarning('common.messages.fileSizeError')
                break
            default:
                this.showError(errorData?.message ?? 'errorMessages.badRequestMessage')
        }
    }

    private showError(message: string | { [key: string]: ObjectValidationError }): void {
        if (isObject(message)) {
            let areFieldErrors: boolean = false
            forEach(message, (value) => {
                areFieldErrors = areFieldErrors || !isEmpty(value.fieldErrors)
                forEach(value.globalErrors, (error) => this.toastService.showWarning(error))
            })
            if (areFieldErrors) {
                this.toastService.showWarning('errorMessages.incorrectlyFilledFields')
            }
        } else {
            this.toastService.showWarning(message)
        }
    }
}
